import { configureStore } from '@reduxjs/toolkit'
import user from './user/slice'
import ui from './ui/slice'
import subscription from './subscription/slice'
import invoices from './invoices/slice'
import organization from './organization/slice'
import expenses from './expenses/slice'
import business from './business/slice'
import tags from './tags/slice'
import tagGroups from './tagGroups/slice'
import budgets from './budgets/slice'
import downloadJobs, { DOWNLOAD_JOBS_STORAGE_KEY } from './downloadJobs/slice'

export const store = configureStore({
  reducer: {
    user,
    invoices,
    ui,
    subscription,
    organization,
    expenses,
    business,
    tags,
    tagGroups,
    budgets,
    downloadJobs
  }
})

let lastPersistedJobs = store.getState().downloadJobs
store.subscribe(() => {
  const current = store.getState().downloadJobs
  if (current === lastPersistedJobs) return
  lastPersistedJobs = current
  try {
    sessionStorage.setItem(DOWNLOAD_JOBS_STORAGE_KEY, JSON.stringify(current))
  } catch {
    // Ignore storage failures (quota exceeded, private mode, etc.)
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
